<script setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import PostSaleManagementDeedsChart from './PostSaleManagementDeedsChart.vue';
import PostSaleManagementDeedsFilters from './PostSaleManagementDeedsFilters.vue';
import PostSaleManagementDeedsTable from './PostSaleManagementDeedsTable.vue';

const props = defineProps({
  data: { type: Object, required: true },
  loading: { type: Boolean, default: false },
  period: { type: Object, required: true },
});

const emit = defineEmits(['openCase', 'setPeriod']);
const { t } = useI18n();
const page = ref(1);
const pageSize = ref(5);
const year = new Date().getFullYear();
const years = Array.from({ length: year - 1989 }, (_, index) => ({
  label: String(year - index),
  value: year - index,
}));
const months = computed(() => [
  { label: t('POST_SALE.MANAGEMENT.MONTHS.ALL'), value: 0 },
  { label: t('POST_SALE.MANAGEMENT.MONTHS.1'), value: 1 },
  { label: t('POST_SALE.MANAGEMENT.MONTHS.2'), value: 2 },
  { label: t('POST_SALE.MANAGEMENT.MONTHS.3'), value: 3 },
  { label: t('POST_SALE.MANAGEMENT.MONTHS.4'), value: 4 },
  { label: t('POST_SALE.MANAGEMENT.MONTHS.5'), value: 5 },
  { label: t('POST_SALE.MANAGEMENT.MONTHS.6'), value: 6 },
  { label: t('POST_SALE.MANAGEMENT.MONTHS.7'), value: 7 },
  { label: t('POST_SALE.MANAGEMENT.MONTHS.8'), value: 8 },
  { label: t('POST_SALE.MANAGEMENT.MONTHS.9'), value: 9 },
  { label: t('POST_SALE.MANAGEMENT.MONTHS.10'), value: 10 },
  { label: t('POST_SALE.MANAGEMENT.MONTHS.11'), value: 11 },
  { label: t('POST_SALE.MANAGEMENT.MONTHS.12'), value: 12 },
]);
const rows = computed(() => props.data.linha_tempo_status || []);
const paginatedRows = computed(() => {
  const offset = (page.value - 1) * pageSize.value;
  return rows.value.slice(offset, offset + pageSize.value);
});
const updatePeriod = value => emit('setPeriod', value);
const changePage = value => {
  page.value = value;
};
const changePageSize = value => {
  pageSize.value = value;
  page.value = 1;
};
const longestSaleDays = computed(() =>
  Math.max(...rows.value.map(row => row.todos_status.total_dias), 0)
);

watch(rows, () => {
  page.value = 1;
});
</script>

<template>
  <section class="flex flex-col gap-4">
    <PostSaleManagementDeedsFilters
      :period="period"
      :months="months"
      :years="years"
      @set-period="updatePeriod"
    />
    <PostSaleManagementDeedsChart
      :rows="data.grafico_linhas || []"
      :loading="loading"
    />
    <PostSaleManagementDeedsTable
      :rows="rows"
      :paginated-rows="paginatedRows"
      :loading="loading"
      :page="page"
      :page-size="pageSize"
      :longest-sale-days="longestSaleDays"
      @open-case="emit('openCase', $event)"
      @change-page="changePage"
      @change-page-size="changePageSize"
    />
  </section>
</template>
